/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { formatMonth } from '../../data/format-month';
import Loading from '../../component/Loading';
import { bilimMerkezAPI } from '../../api';

const BlogSidebar = ({ news_id }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const { t, i18n } = useTranslation();
  const lang = i18n.language === 'tk' ? 'tm' : i18n.language;

  const formatDate = (date) => {
    const month = date?.split('T')[0]?.split('-')[1];
    return `${formatMonth(month, lang)} ${moment(date).format('DD, YYYY')}`;
  };

  const getLocalizedTitle = (item) =>
    item?.[`title_${lang}`] ||
    item?.title_tm ||
    item?.title_ru ||
    item?.title_en ||
    '';

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await bilimMerkezAPI.get('/notices', {
          params: {
            lang,
            limit: 5,
            offset: 0,
          },
        });
        setData(res.data?.results || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [lang]);

  return (
    <div className="sidebar-widget-wrapper">
      <div className="sidebar__widget mb-30">
        <div className="sidebar__widget-head mb-35">
          <h4 className="sidebar__widget-title">{t('other_announcements')}</h4>
        </div>
        <div className="sidebar__widget-content">
          {loading ? (
            <div className="flex justify-center items-center w-full">
              <Loading style={{ width: '10%' }} />
            </div>
          ) : (
            <div className="rc__post-wrapper">
              {data
                .filter((item) => item.slug !== news_id)
                .map((item) => (
                  <div
                    key={item.id}
                    className="rc__post d-flex align-items-center"
                  >
                    <div className="rc__thumb mr-20">
                      <Link to={`/announcement-details/${item.slug}`}>
                        {item.image && (
                          <img
                            src={item.image}
                            alt="img"
                            style={{
                              width: 'auto',
                              height: '80px',
                              aspectRatio: '1/1',
                              objectFit: 'contain',
                              borderRadius: '4px',
                            }}
                          />
                        )}
                      </Link>
                    </div>
                    <div className="rc__content">
                      <div className="rc__meta">
                        <span className="capitalize">
                          {formatDate(item.published_date)}
                        </span>
                      </div>
                      <h6 className="rc__title">
                        <Link to={`/announcement-details/${item.slug}`}>
                          {getLocalizedTitle(item)}
                        </Link>
                      </h6>
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlogSidebar;
